document.addEventListener("DOMContentLoaded", function () {
  const productForms = document.querySelectorAll('form[data-type="add-to-cart-form"]');
  productForms.forEach((form) => {
    const formId = form.id;
    const quantityInputs = document.querySelectorAll(
      `input[name="quantity"][form="${formId}"], .modern-quantity-selector .quantity-input[form="${formId}"]`,
    );
    if (quantityInputs.length === 0) return;
    form.addEventListener("submit", function (e) {
      const activeQuantityInput = quantityInputs[0];
      const quantity = parseInt(activeQuantityInput.value) || 1;
      form.querySelectorAll('input[type="hidden"][name="quantity"]').forEach((input) => {
        input.remove();
      });
      const qtyInput = document.createElement("input");
      qtyInput.type = "hidden";
      qtyInput.name = "quantity";
      qtyInput.value = quantity;
      form.appendChild(qtyInput);
    });
  });

  function handleResponsiveProductTitles() {
    const productTitles = document.querySelectorAll(".shop-product-title[data-font-size][data-mobile-font-size]");

    function adjustAllTitles() {
      const isMobile = window.innerWidth <= 767;
      productTitles.forEach((title) => {
        const size = isMobile ? title.getAttribute("data-mobile-font-size") : title.getAttribute("data-font-size");
        title.style.setProperty("font-size", `${size}px`, "important");
      });
    }

    // Un seul listener pour tous les titres
    adjustAllTitles();

    if (!window.titleResizeHandlerAdded) {
      window.addEventListener("resize", adjustAllTitles);
      window.titleResizeHandlerAdded = true;
    }
  }
  handleResponsiveProductTitles();
  function initFaqAccordions() {
    const faqContainers = document.querySelectorAll(".product-faq");
    faqContainers.forEach((faqContainer) => {
      const faqId = faqContainer.id;
      if (!faqId) return;
      const faqItems = faqContainer.querySelectorAll(".faq-item");
      const innerFaqContainer = faqContainer.querySelector(".faq-container");
      const isAccordion = innerFaqContainer && innerFaqContainer.getAttribute("data-accordion") === "true";
      faqItems.forEach((item) => {
        const question = item.querySelector(".faq-question");
        if (!question) return;
        if (!question.hasAttribute("data-click-listener-added")) {
          question.setAttribute("data-click-listener-added", "true");
          question.addEventListener("click", () => {
            const isActive = item.classList.contains("active");
            if (isAccordion && !isActive) {
              faqItems.forEach((otherItem) => {
                otherItem.classList.remove("active");
              });
            }
            item.classList.toggle("active");
          });
        }
      });
    });
  }
  initFaqAccordions();
  const readMoreLinks = document.querySelectorAll(".shop-read-more");
  const readLessLinks = document.querySelectorAll(".shop-read-less");
  readMoreLinks.forEach((link) => {
    link.addEventListener("click", function (e) {
      e.preventDefault();
      const parent = this.closest(".shop-product-description");
      parent.querySelector(".shop-truncated-description").style.display = "none";
      parent.querySelector(".shop-full-description").style.display = "block";
    });
  });
  readLessLinks.forEach((link) => {
    link.addEventListener("click", function (e) {
      e.preventDefault();
      const parent = this.closest(".shop-product-description");
      parent.querySelector(".shop-truncated-description").style.display = "block";
      parent.querySelector(".shop-full-description").style.display = "none";
    });
  });
});

/* Cellnce: keep the price "SAVE %" badge in sync when a bundle app (e.g. Kaching) changes the displayed price */
(function () {
  function num(el) {
    if (!el) return NaN;
    var t = (el.textContent || "").replace(/[^0-9.,]/g, "");
    if (t.indexOf(",") > -1 && t.indexOf(".") === -1) t = t.replace(",", ".");
    return parseFloat(t.replace(/,/g, ""));
  }
  function update(box) {
    var priceEl = box.querySelector(".shop-product-price-block");
    var compareEl = box.querySelector(".shop-compare-price");
    var badge = box.querySelector(".shop-save-price");
    if (!priceEl || !compareEl || !badge) return;
    var p = num(priceEl), c = num(compareEl);
    if (!(p > 0) || !(c > p)) { badge.style.display = "none"; return; }
    badge.style.display = "";
    var pct = Math.round(((c - p) * 100) / c) + "%";
    var sym = (priceEl.textContent.match(/[^0-9.,\s]+/) || ["$"])[0];
    var amt = sym + (c - p).toFixed(2);
    var walker = document.createTreeWalker(badge, NodeFilter.SHOW_TEXT, null);
    var node;
    while ((node = walker.nextNode())) {
      var v = node.nodeValue, nv = v;
      if (/\d+(\.\d+)?\s*%/.test(v)) nv = v.replace(/\d+(\.\d+)?\s*%/, pct);
      else if (/[^\s\d.,A-Za-z]\s?[\d.,]+\d/.test(v)) nv = v.replace(/[^\s\d.,A-Za-z]\s?[\d.,]+\d/, amt);
      if (nv !== v) node.nodeValue = nv;
    }
  }
  function init() {
    document.querySelectorAll(".shop-product-price-container").forEach(function (box) {
      if (box.dataset.saveSync) return;
      box.dataset.saveSync = "1";
      var run = function () { update(box); };
      new MutationObserver(run).observe(box, { childList: true, subtree: true, characterData: true });
      document.addEventListener("change", function () { setTimeout(run, 50); setTimeout(run, 400); });
      document.addEventListener("click", function () { setTimeout(run, 400); });
      run();
    });
  }
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", init);
  else init();
})();
